const LaptopSoundType = {
    OPEN: "device_open",
    CLOSE: "device_close",

    NOTIFICATION: "laptop_notification",

    CLICK: "click"
};

export default LaptopSoundType;